import { render, staticRenderFns } from "./SMenuPcComp.vue?vue&type=template&id=eb1d3a6e&"
import script from "./SMenuPcComp.vue?vue&type=script&lang=js&"
export * from "./SMenuPcComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports